import React, { useState } from 'react';
import { METRIC_DEFINITIONS, MetricKey } from './metricDefinitions';

/**
 * The ⓘ beside a derived metric. The bubble is `position: fixed` at the icon's
 * screen position so it escapes the overflow-hidden cards and scrolling tables
 * these sit inside.
 */
export function InfoTip({ metric }: { metric: MetricKey }): React.ReactElement {
  const [at, setAt] = useState<{ x: number; y: number } | null>(null);
  const text = METRIC_DEFINITIONS[metric];

  const show = (e: React.SyntheticEvent<HTMLElement>) => {
    const r = e.currentTarget.getBoundingClientRect();
    setAt({ x: Math.min(Math.max(r.left + r.width / 2, 136), window.innerWidth - 136), y: r.bottom + 6 });
  };
  const hide = () => setAt(null);

  return (
    <span
      tabIndex={0}
      role="note"
      aria-label={text}
      onMouseEnter={show}
      onMouseLeave={hide}
      onFocus={show}
      onBlur={hide}
      className="ml-1 inline-flex h-3.5 w-3.5 shrink-0 cursor-help select-none items-center justify-center rounded-full border border-gray-600 align-middle text-[9px] font-semibold normal-case leading-none tracking-normal text-gray-500 hover:border-gray-400 hover:text-gray-300 focus:outline-none focus:border-violet-500"
    >
      i
      {at && (
        <span
          style={{ left: at.x, top: at.y }}
          className="pointer-events-none fixed z-[100] w-64 -translate-x-1/2 rounded-lg border border-gray-700 bg-gray-950 px-3 py-2 text-left text-[11px] font-normal normal-case leading-snug tracking-normal text-gray-300 shadow-xl whitespace-normal"
        >
          {text}
        </span>
      )}
    </span>
  );
}

export default InfoTip;
